import { createDialog } from '@/infrastructure/decorators/dialog';
export function createShareSpaceDialog() {
    return createDialog(() => import('./components/ShareSpaceDialog.vue'));
}
